(function (window, document, $) {

    $(document).ready(function () {
        // Update header to get around full-page caching ===============================================================

        function updateHeader() {
            if ($('.header__main').length < 1) {
                return;
            }

            var page = themevars.postID;

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'ym_get_header_login_data',
                    page: page,
                    pagepath: window.location.pathname,
                    category: themevars.category
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (true !== result.success) {
                    return;
                }

                // show element only in certain situaties
                if( $('[data-show-when]').length ) {
                    $('[data-show-when]').each(function() {
                        var show_when = $(this).data('show-when');

                        if( show_when === "has_subscription" && result.data.yotv ) {
                            $(this).removeClass('d-none');
                            $(document).trigger('update-card-slider');
                        }

                        if( show_when === "no_subscription" && result.data.yotv ) {
                            $(this).addClass('d-none');
                        }
                    });
                }

                if ($('[data-yogatv-spotlight]').length && result.data.yogatv_spotlight_videos) {
                    $('[data-yogatv-spotlight]').html(result.data.yogatv_spotlight_videos);
                }

                if (result.data.logged_in && result.data.yotv) {
                    $('.filter--video a[href="#dropdown-video-account"]').text('Mijn Yogatv ');
                } else {
                    $('.filter--video a[href="#dropdown-video-account"]').text('Inloggen ');
                }

                if (result.data.list_data) {
                    $.each(result.data.list_data, function (post_type, list_data) {
                        if (post_type && post_type !== "fav-vids") {
                            // load the amount of posts present in the cookie
                            var load_more_button = $('.button--load-more[data-load-more-type="' + post_type + '"]');

                            if ($(load_more_button).length > 0) {
                                var default_amount = $(load_more_button).data("load-more-amount");
                                var default_offset = parseInt($(load_more_button).data("load-more-offset"));
                                var load_more_amount = list_data["loaded"] - default_offset;

                                // Only perform "load more" action in old situation - since we want to re-use our own Filter query
                                if (load_more_amount > 0 && !themevars.restyling) {
                                    $(load_more_button).data("load-more-amount", load_more_amount);
                                    $(load_more_button).click();
                                    $(load_more_button).data("load-more-amount", default_amount);
                                }
                            }
                        }
                    });
                }

            });
        }

        updateHeader();

        $('body').on('updated_cart_totals', function (e, data) {
            updateHeader();
        });


        if (themevars.restyling) {

            var initialPos = $('header.header').offset().top;
            var intervalId = 0;

            // Hide Header on scroll down show on scroll up on < tablet
            function fixedHeaderYogaTV() {
                var navbarHeight = $('header.header').outerHeight();
                var shouldBeSticky = $('.filter .is-desktop').is(':visible');

                if (shouldBeSticky) {
                    $('nav.filter').attr('data-sticky', '');
                } else {
                    $('nav.filter[data-sticky]').attr('data-sticky', false);
                }

                // add wrapper with the same height as the header to keep the page from jumping when the header becomes fixed
                if( !$('.header-wrapper').length ) {
                    $('header.header').wrap( '<div class="header-wrapper"></div>' );
                }
                
                $('.header-wrapper').css( 'height', navbarHeight );

                if ($(window).width() <= 992) {
                    var didScroll;
                    var lastScrollTop = 0;
                    var delta = 5;

                    $(window).scroll(function (event) {
                        didScroll = true;
                    });

                    if (intervalId) {
                        clearInterval(intervalId);
                    }
                    intervalId = setInterval(function () {
                        if (didScroll) {
                            if ($(window).width() <= 992) {
                                hasScrolled();
                                didScroll = false;
                            }
                        }
                    }, 250);
                    function hasScrolled() {
                        var st = $(window).scrollTop();

                        // Make sure they scroll more than delta
                        if (Math.abs(lastScrollTop - st) <= delta) {
                            return;
                        }

                        // If they scrolled down and are past the navbar, add class .nav-up.
                        // This is necessary so you never see what is "behind" the navbar.
                        if (st > lastScrollTop && st > navbarHeight) {
                            // Scroll Down
                            $('header.header').removeClass('nav-down').addClass('nav-up');
                            if ($('.filter--video.is-sticky').length) {
                                $('.filter--video.is-sticky').css('top', '0px');
                            }
                        } else if (st <= (initialPos + 10)) {
                            $('header.header').removeClass('nav-down').removeClass('nav-up');
                            $('.filter--video').css('top', '0px');
                        } else {
                            // Scroll Up
                            if (st + $(window).height() < $(document).height()) {
                                $('header.header').removeClass('nav-up').addClass('nav-down');
                                if ($('.filter--video.is-sticky').length) {
                                    $('.filter--video.is-sticky').css('top', '60px');
                                }
                            }
                        }

                        lastScrollTop = st;
                    }
                } else {
                    $('header.header').removeClass('nav-down').removeClass('nav-up');
                }
            }

            $(window).resize(function () {
                $('header.header').removeClass('nav-down').removeClass('nav-up');
                $('.filter--video').css('top', '0px');
                initialPos = $('header.header').offset().top;
                fixedHeaderYogaTV();
            });

            fixedHeaderYogaTV();
        }
    });

}(window, document, jQuery));
